import { CartDispensary } from "@/custom-types/CartDispensary";
import { Dispensary } from "@/custom-types/Dispensary";

const getDispensaryPrimaryAddress = (dispensary: Dispensary | CartDispensary) =>
  [dispensary.address1, dispensary.address2, dispensary.city, dispensary.state]
    .filter((addressPart) => !!addressPart)
    .join(", ");

export default getDispensaryPrimaryAddress;
